import React, { useEffect, useState } from 'react'

function Counter({target}) {
    const [count, setCount] = useState(0);
    const speed = 100;

    useEffect(() => {
        let currentCount = 0;
        const increment = target / speed;

        const updateCount = () => {
            if (currentCount < target) {
                currentCount += increment;
                setCount(Math.ceil(currentCount));
                setTimeout(updateCount, 1);
            } else {
                setCount(target);
            }
        };

        updateCount();
    }, [target]);

    return <>{count}</>;
}
export default Counter
